export const SortTypeHelp = {
  ALPHABET: 'alph', // От А до Я и наоборот
  RATE: 'rate', // от лучших к худшим и наоборот
  DATE: 'new', // от старых к новым и наоборот
  GENERAL: 'general', // от готового к проверке до неготового и наоборот
  COUNT: 'count', // от большего к меньшему и наоборот
};
